<template>
    <b-modal
        id="portfolio-create-calendar-item-modal"
        size="md"
        ref="portfolio-create-calendar-item-modal"
        title="Nieuw agenda item"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="onOk"
        @show="onShow"
        dialog-class="assignment-modal"
        modal-class="apprentice-default-modal portfolio-add-calendar"
        body-class="portfolio-add-body"
        :no-enforce-focus="true">
        <b-alert
            v-if="hasErrors"
            show
            variant="danger">
            {{ errorMessage }}
        </b-alert>

        <div class="title">
            <b-form-group label="Title:">
                <template v-slot:label> Titel: <span class="required">*</span> </template>
                <b-form-input
                    id="input-1"
                    v-model="title"
                    required
                    placeholder="Titel">
                </b-form-input>
            </b-form-group>
        </div>

        <div
            class="description"
            :class="description === placeholderText && 'placeholder-visible'">
            <b-form-group label="Omschrijving:">
                <ckeditor
                    v-model="description"
                    :editor="editor"
                    :config="editorConfig"
                    @focus="clearPlaceholder"
                    @blur="showPlaceholder"
                    placeholder="Omschrijving">
                </ckeditor>
            </b-form-group>
        </div>

        <div class="location">
            <b-form-group label="Locatie:">
                <b-form-input
                    id="input-2"
                    v-model="location"
                    required
                    placeholder="Locatie..."></b-form-input>
            </b-form-group>
        </div>

        <div class="dates">
            <div class="start-date-time">
                <b-form-group label="Startdatum:">
                    <template v-slot:label> Startdatum: <span class="required">*</span> </template>
                    <b-input-group>
                        <b-input-group-append>
                            <b-form-datepicker
                                class="apprentice-date-picker btn-date-group"
                                v-model="startDate"
                                start-weekday="1"
                                now-button
                                reset-button
                                right
                                today-variant="primary"
                                nav-button-variant="primary"
                                locale="nl"
                                aria-controls="Kies een datum"
                                label-reset-button="reset"
                                label-no-date-selected="Geen datum geselecteerd"
                                menu-class="datedropdown"
                                :date-format-options="{
                                    year: 'numeric',
                                    month: 'short',
                                    day: '2-digit',
                                    weekday: 'short',
                                }">
                            </b-form-datepicker>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>

                <b-form-group label="Einddatum:">
                    <b-input-group>
                        <b-input-group-append>
                            <b-form-datepicker
                                class="apprentice-date-picker btn-date-group"
                                v-model="endDate"
                                start-weekday="1"
                                now-button
                                reset-button
                                right
                                today-variant="primary"
                                nav-button-variant="primary"
                                locale="nl"
                                aria-controls="Kies een datum"
                                label-reset-button="Reset"
                                label-no-date-selected="Kies een datum"
                                menu-class="datedropdown"
                                :date-format-options="{
                                    year: 'numeric',
                                    month: 'short',
                                    day: '2-digit',
                                    weekday: 'short',
                                }"
                                :initial-date="getMinDate"
                                :min="getMinimumRequiredDate">
                            </b-form-datepicker>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </div>

            <div class="end-date-time">
                <b-form-group label="Starttijd:">
                    <design-2021-apprentice-timepicker-component v-model="startTime">
                    </design-2021-apprentice-timepicker-component>
                </b-form-group>

                <b-form-group label="Eindtijd:">
                    <design-2021-apprentice-timepicker-component v-model="endTime">
                    </design-2021-apprentice-timepicker-component>
                </b-form-group>
            </div>
        </div>
    </b-modal>
</template>

<script>
import ApprenticeEditor from '../../../../../../../helpers/ApprenticeEditor';
import $ from 'jquery';

export default {
    name: 'design-2021-portfolio-show-calendar-add-item-modal-component',
    props: ['projectId', 'projectType'],
    data() {
        return {
            title: null,
            placeholderText: '<p>Voer de omschrijving in...</p>',
            description: '<p>Voer de omschrijving in...</p>',
            location: null,
            startDate: null,
            startTime: null,
            endDate: null,
            endTime: null,
            editor: ApprenticeEditor,
            editorConfig: {
                contentsCss: 'test',
                bodyClass: 'mybodyclass',
                toolbar: {
                    items: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        'undo',
                        'redo',
                    ],
                },
                language: this.$authUser.locale,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
            },
            hasErrors: false,
            errorMessage: '',
        };
    },

    methods: {
        onShow() {
            this.title = null;
            this.description = this.placeholderText;
            this.location = null;
            this.startDate = null;
            this.startTime = null;
            this.endDate = null;
            this.endTime = null;
            this.hasErrors = false;
            this.errorMessage = 'Niet alle verplichte velden zijn correct ingevuld.';
        },

        onOk(bvModal) {
            if (!this.isFormValidated()) {
                bvModal.preventDefault();
                $('.apprentice-default-modal').animate({ scrollTop: 0 }, 500);
                return;
            }

            this.alert.saving();

            let uri = `paper/${this.projectId}/agenda/create`;
            let data = {
                title: this.title,
                description: this.description === this.placeholderText ? null : this.description,
                location: this.location,
                date: this.startDate,
                time: this.startTime,
                end_date: this.endDate,
                end_time: this.endTime,
                agenda_type: this.projectType,
            };

            axios
                .post(uri, data)
                .then((response) => {
                    this.title = null;
                    this.description = this.placeholderText;
                    this.location = null;
                    this.startDate = null;
                    this.startTime = null;
                    this.endDate = null;
                    this.endTime = null;
                    this.$emit('updateAgendaItems', response.data);
                    this.alert.success();
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        this.errors = error.response.data.errors;
                    } else {
                        this.alert.ajaxError(error);
                    }
                });
        },

        clearPlaceholder() {
            if (this.description === this.placeholderText) {
                this.description = '';
            }
        },

        showPlaceholder() {
            if (this.description === '') {
                this.description = this.placeholderText;
            }
        },

        isFormValidated() {
            this.hasErrors =
                this.title === '' || this.title === null || this.startDate === '' || this.startDate === null;

            if (!this.hasErrors && this.startDate === this.endDate && this.startTime === this.endTime) {
                this.hasErrors = true;
                this.errorMessage = 'Startdatum en starttijd mogen niet gelijk zijn aan de einddatum en eindtijd.';
            }

            if (!this.hasErrors && this.startDate === this.endDate && this.endTime < this.startTime) {
                this.hasErrors = true;
                this.errorMessage =
                    'De eindtijd kan niet eerder zijn dan de starttijd wanneer de startdatum en einddatum gelijk zijn.';
            }

            return !this.hasErrors;
        },
    },

    computed: {
        getMinDate() {
            let minRequiredDate = this.startDate !== '' ? new Date(this.startDate) : new Date();
            minRequiredDate.setMonth(minRequiredDate.getDay() + 1);
            return minRequiredDate;
        },

        getMinimumRequiredDate() {
            return this.startDate !== '' ? new Date(this.startDate) : new Date();
        },
    },
};
</script>

<style scoped lang="scss">
input.form-control {
    margin-bottom: 0;
}

.dates {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;

    .apprentice-date-picker {
        margin-bottom: 0;
    }

    .start-date-time,
    .end-date-time {
        flex: 1 0 100%;

        .input-group-append {
            width: inherit;
        }

        .apprentice-default-time-picker ::v-deep {
            input {
                margin-bottom: 0;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .dates {
        .start-date-time {
            flex: 1;
            margin-right: 30px;

            .input-group-append {
                width: inherit;
            }
        }

        .end-date-time {
            flex: 0 0 200px;
        }
    }
}
</style>
